import { render } from "./AssistantMobileIcon.vue?vue&type=template&id=3e3ee8cc&scoped=true"
import script from "./AssistantMobileIcon.vue?vue&type=script&lang=js"
export * from "./AssistantMobileIcon.vue?vue&type=script&lang=js"

import "./AssistantMobileIcon.vue?vue&type=style&index=0&id=3e3ee8cc&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e3ee8cc"]])

export default __exports__